<template>
    <div id="goodsChangeAdd">
        <div class="invoicingHead" style="height:40px;">
            <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <a @click="goBack" href="javascript:;">选择商品</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>新增调拨</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="searchGroup">
            <el-form ref="refundForm" :model="refundForm" label-width="85px">
                <el-form-item label="出库仓库">{{repositoryOutName}}</el-form-item>
                <el-form-item label="入库仓库">{{repositoryInName}}</el-form-item>
                <el-form-item label="已选商品">
                    <div class="flex-start">
                        <div style="padding-right: 20px;">共{{chechedNum}}件商品</div>
                        <div @click="jumpTT('/invoicingFather/chooseGoods')" class="look-detail pl20">查看详情</div>
                    </div>
                </el-form-item>
                <el-form-item label="业务日期">
                    <el-date-picker style="width:220px;" :clearable="false" v-model="refundForm.businessTime" type="datetime" placeholder="选择业务日期" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                </el-form-item>
                <el-form-item label="经手人">
                    <el-select size="small" v-model="refundForm.handlerId" placeholder="经手人" style="width:220px;">
                        <el-option v-for="item in handlerList" :key="item.shopWorkerUserId" :label="item.fullName" :value="item.shopWorkerUserId"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="其他费用">
                    <el-input v-model="refundForm.otherFree" style="width:220px;"></el-input>
                </el-form-item> -->
                <el-form-item label="结算账户：">现金</el-form-item>
                <el-form-item label="备注信息：">
                    <el-input placeholder="输入备注信息" type="textarea" style="width:480px;" v-model="refundForm.remarks"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="confirmSave">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { Shop_handlerList, saveGoodsChange } from '../api';
export default {
    data() {
        return {
            userList: {},
            checkedList: [],
            chechedNum: 0,
            refundForm: {
                repositoryInId: "",
                repositoryOutId: "",
                businessTime: "",
                handlerId: "",
                otherFree: "",
                remarks: ""
            },
            repositoryInName: "",
            repositoryOutName: "",
            handlerList: []
        }
    },
    created() {
        let userList = JSON.parse(this.getCookie("userList"));
        this.userList = userList;
        this.Shop_handlerList()
        this.checkedList = JSON.parse(localStorage.getItem("confirmChooseList") || "[]")
        var res = this.checkedList.filter(function (item,index,arr ) { 
          return item.click == true; 
        }) 
        this.chechedNum = res.length
        console.log(res, "新数组", this.chechedNum)
        var productJson = [];
        res.forEach(function(item){
          productJson.push({goodsId: item.goodsId, productId: item.productId, goodsNum: item.goodsNum})
        })
        this.lists = productJson
        console.log(this.lists, productJson)
        this.repositoryInName = localStorage.getItem("repositoryInName")
        this.repositoryOutName = localStorage.getItem("repositoryOutName")
        this.refundForm.repositoryOutId = localStorage.getItem("repositoryOutId")
        this.refundForm.repositoryInId = localStorage.getItem("repositoryInId")
        console.log(localStorage.getItem("repositoryInName"), localStorage.getItem("repositoryOutName"), localStorage.getItem("repositoryOutId"), localStorage.getItem("repositoryInId"))

        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        if (month < 10) {
            month = '0' + month
        }
        var dates = date.getDate();
        if (dates < 10) {
            dates = '0' + dates
        }
        var hour = date.getHours();
        var minutes = date.getMinutes();
        // var second = date.getSeconds();
        var dataTime = year + "-" + month + "-" + dates + " " + hour + ":" + minutes;
        console.log(dataTime, "dataTime")   
        this.refundForm.businessTime = dataTime
    },
    methods: {
        //跳转
        jumpTT(adress, message) {
          this.$router.push({ path: adress, query: { docId: message } });
        },
        goBack() {
          this.$router.push({ path: '/invoicingFather/chooseGoods', query: { goodsStyle: this.$route.query.goodsStyle}})
        },
        dataTimeChoose() {

        },
        // 经手人列表
        Shop_handlerList() {
            Shop_handlerList({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                pageNo: 1,
                row: 99999
            })
            .then(res => {
                if (res.code == 1) {
                    this.handlerList = res.data[0].workers
                    this.refundForm.handlerId = res.data[0].workers[0].shopWorkerUserId
                }
            })
        },
        // 保存
        confirmSave() {
            saveGoodsChange({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                handlerId: this.refundForm.handlerId,
                remarks: this.refundForm.remarks,
                repositoryInId: this.refundForm.repositoryInId,
                repositoryOutId: this.refundForm.repositoryOutId,
                businessTime: this.refundForm.businessTime,
                productJson: JSON.stringify(this.lists)
            })
            .then(res => {
                if (res.code == 1) {
                    this.$router.push("/invoicingFather/goodsChange")
                    this.$message.success(res.msg)
                    localStorage.removeItem("confirmChooseList")
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
}
</script>

<style scoped>
.searchGroup {
  position: absolute;
  top: 120px;
  padding-left: 25px;
  box-sizing: border-box;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.pl20 {
    padding-left: 20px;
}
.look-detail {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: rgba(16,142,233,1);
    cursor: pointer;
}
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/components/page/goodsChangeAdd.vue